import {SMALL} from './BreakPoints.js'
/*
    Responsive props to hold all the props relevant for device info and layout
    Immediate extension with spacing for Desktop and mobile
*/
export const responsiveProps = {

    isMobile : {
        default : false,
        [SMALL] : true
    },
    spacingInset_shorthand2 : {
        default : "small large",
        [SMALL] : "small",
    },
    spacingInset_shorthand3 : {
        default : "medium large",
        [SMALL] : "small medium",
    },
    spacingInset_shorthand4 : {
        default : "large",
        [SMALL] : "small",
    },
}


// WEBPACK FOOTER //
// ./src/components/common/constant/ResponsiveProps.js